import React from "react";
import { Col, List, Row } from "antd";

export const UniqueValuesList = ({ data }) => {
	return (
		<List
			bordered
			pagination={{ pageSize: 10 }}
			style={{ width: "100%", overflow: "auto", maxHeight: "300px" }}
			dataSource={data}
			renderItem={(item, index) => {
				return (
					<List.Item
						style={{
							width: "100%",
							background: index % 2 === 0 ? "#f7f7f7" : "#ffffff",
							borderRadius: "8px"
						}}
					>
						<Row gutter={[12, 20]}>
							<Col span={24}>{item}</Col>
						</Row>
					</List.Item>
				);
			}}
		/>
	);
};

export default UniqueValuesList;
